import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center text-truncate" }
const _hoisted_2 = { class: "attachment-icon" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "size" }

import {computed} from 'vue';
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {IMessageAttachment} from "~/chat/ts/data/chat/IMessage";
import ChatUploadHelper from "~/chat/ts/service/ChatUploadHelper";


const __default__ = {
    name: "ChatMessageFileContentDescription"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attachment: {},
    icon: {}
  },
  setup(__props: any) {

let props = __props;

let fileSize = computed(() => {
    if (props.attachment.size > 0) {
        return ChatUploadHelper.sizeToString(Math.ceil(props.attachment.size));
    } else {
        return null;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SvgIcon, {
        "icon-name": _ctx.icon ? _ctx.icon : 'file',
        "icon-style": "light"
      }, null, 8, ["icon-name"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.attachment.fileName), 1),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.$slots.size)
          ? _renderSlot(_ctx.$slots, "size", { key: 0 })
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_unref(fileSize)), 1)
            ], 64))
      ])
    ])
  ]))
}
}

})